// extracted by mini-css-extract-plugin
module.exports = {"menu-tree":"MrugR","title":"AgggH","icon":"hS0vR","link":"Qwd34","hasMore":"LKT8K","hasMoreIcon":"chfmr","aggregator":"dGYb+","open":"OLZpB"};